import { useLDClient } from 'launchdarkly-react-client-sdk'
import { useEffect } from 'react'
import { FeatureFlagClient } from '../feature-flag-client'

/**
 * Hook de inicialização do sistema de feature flags.
 *
 * Deve ser chamado uma única vez no topo da árvore de componentes autenticados
 * (ex: AccountProvider). Sincroniza o cliente LaunchDarkly com o FeatureFlagClient
 * singleton, habilitando leitura de flags em contextos não-React (guards, loaders).
 *
 * Não retorna nada — existe apenas pelo efeito colateral de sincronização.
 * Após chamado, `FeatureFlagClient.identifyUser()` pode ser usado sem parâmetros.
 *
 * Contrato de ordem: este hook deve ser declarado ANTES de qualquer useEffect
 * que chame `FeatureFlagClient.identifyUser()` no mesmo componente. O React
 * garante que effects rodam na ordem de declaração dos hooks.
 *
 * @example
 * function AccountProvider() {
 *   useFeatureFlagSync()  // ← primeiro
 *
 *   useEffect(() => {
 *     FeatureFlagClient.identifyUser(accountData)  // ← depois
 *   }, [])
 * }
 */
export function useFeatureFlagSync(): void {
  const ldClient = useLDClient()

  useEffect(() => {
    FeatureFlagClient.syncWithClient(ldClient)
  }, [ldClient])
}
